import React from 'react';
import { Box, Paper, Typography, LinearProgress, IconButton } from '@mui/material';
import { Close as CloseIcon, CloudUpload as CloudUploadIcon, CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';
import { useUpload } from '../../contexts/UploadContext';

const UploadTracker = () => {
    const { uploads, removeUpload } = useUpload();
    const activeUploads = Object.values(uploads);

    if (activeUploads.length === 0) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: 350,
                width: '100%',
            }}
        >
            {activeUploads.map((upload) => (
                <Paper
                    key={upload.id}
                    elevation={6}
                    sx={{
                        p: 2,
                        borderRadius: 2,
                        background: 'rgba(30, 30, 30, 0.95)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        color: 'white',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Box sx={{ mr: 1, color: upload.status === 'failed' ? '#ff4d4d' : upload.status === 'success' ? '#4caf50' : '#4285f4' }}>
                            {upload.status === 'failed' ? <ErrorIcon fontSize="small" /> :
                                upload.status === 'success' ? <CheckCircleIcon fontSize="small" /> :
                                    <CloudUploadIcon fontSize="small" />}
                        </Box>
                        <Typography variant="body2" sx={{ fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {upload.filename}
                        </Typography>
                        {(upload.status === 'success' || upload.status === 'failed') && (
                            <IconButton size="small" onClick={() => removeUpload(upload.id)} sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="caption" sx={{ flex: 1, color: 'rgba(255, 255, 255, 0.7)' }}>
                            {upload.status === 'uploading' ? `${upload.progress}% uploaded` :
                                upload.status === 'verifying' ? 'Finalizing in cloud...' :
                                    upload.status === 'success' ? 'Staged in Cloud' :
                                        upload.error || 'Upload failed'}
                        </Typography>
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>
                            {upload.progress}%
                        </Typography>
                    </Box>

                    <LinearProgress
                        variant="determinate"
                        value={upload.progress}
                        sx={{
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            '& .MuiLinearProgress-bar': {
                                borderRadius: 3,
                                backgroundColor: upload.status === 'failed' ? '#ff4d4d' :
                                    upload.status === 'success' ? '#4caf50' : '#4285f4',
                            }
                        }}
                    />
                </Paper>
            ))}
        </Box>
    );
};

export default UploadTracker;
